import React from 'react';
import { AgeasLogo } from './icons/insurers/Ageas';
import { AllianzLogo } from './icons/insurers/Allianz';
import { EridgeLogo } from './icons/insurers/Eridge';
import { SomersetBridgeLogo } from './icons/insurers/SomersetBridge';
import { AmexLogo } from './icons/payments/AmexLogo';
import { MastercardLogo } from './icons/payments/MastercardLogo';
import { VisaLogo } from './icons/payments/VisaLogo';

type ImageWithName = {
  name: string;
  image: string;
};

type PaymentsAcceptedInput = {
  title: string;
  description: string;
  footer: string;
  insurers: ImageWithName[];
  paymentMethods: ImageWithName[];
};

export const PaymentsAccepted: React.FC<PaymentsAcceptedInput> = ({ title, description, footer }) => {
  return (
    <>
      <h2 className="text-[27px] md:text-[35px]">{title}</h2>

      <div className="mx-auto w-full max-w-[200px] lg:mt-8 lg:max-w-none">
        <div className="flex w-full flex-col flex-wrap items-center justify-center gap-y-10 md:flex-row md:flex-nowrap md:gap-30 md:px-30">
          <EridgeLogo />
          <AllianzLogo />
          <AgeasLogo />
          <SomersetBridgeLogo />
        </div>
      </div>

      <hr className="my-8 border-gray-300" />
      <p className="font-medium">{description}</p>

      <div className="flex flex-wrap items-center justify-center gap-6 pt-6">
        <VisaLogo />
        <MastercardLogo />
        <AmexLogo />
      </div>

      <p className="text-dark pt-4">{footer}</p>
    </>
  );
};
